export const commonListMixin = {
  data() {
    return {
      tableData: [],
      selRow: {},
      searchForm: {},
      submitUrl: '',
      pageCount: 1,
      currentPage: 1,
      pageSize: 10,
      formVisible: false,
      loadTableDataOnMounted: true
    }
  },
  mounted() {
    if (this.loadTableDataOnMounted)
      this.getTableData();
  },
  methods: {
    async getTableData() {
      if (typeof this.beforeGetTableData === 'function') this.beforeGetTableData();
      if (this.searchForm.searchDatetimerange && this.searchForm.searchDatetimerange.length > 0) this.searchForm.startTime = this.searchForm.searchDatetimerange[0];
      if (this.searchForm.searchDatetimerange && this.searchForm.searchDatetimerange.length > 1) this.searchForm.endTime = this.searchForm.searchDatetimerange[1];
      this.searchForm.pageNum = this.currentPage;
      this.searchForm.pageSize = this.pageSize;
      let {obj} = await this.postRequest(this.url.list, this.searchForm);
      this.tableData = obj.list;
      this.pageCount = obj.pages;
    },
    handleCurPageChange(pageIndex) {
      if (pageIndex !== this.currentPage) this.currentPage = pageIndex;
      this.getTableData()
    },
    handleSearchSubmit() {
      this.currentPage = 1;
      this.getTableData()
    },
    handleSearchReset() {
      this.searchForm = {}
    },
    handleAdd() {
      this.submitUrl = this.url.add;
      this.selRow = {};
      this.formVisible = true;
    },
    handleEdit(index, row) {
      this.submitUrl = this.url.edit;
      this.selRow = row;
      this.formVisible = true
    },
    async handleDelete(index, row) {
      let isConfirm = await this.$confirm("确认删除？", '提示', {type: 'warning'}).catch(() => {
      });
      if (!isConfirm) return;
      let params = {};
      if (typeof this.beforeDelete === 'function') params = this.beforeDelete(row);
      params.id = row.id;
      await this.postRequest(this.url.delete, params);
      this.getTableData()
    }
  }
};
